import { c as _c } from "react/compiler-runtime";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { State } from "../../../../store/state";
import { Pane, PaneContainer, PaneTitle } from "../../Panes.style";
import { InfoText } from "../PaymentPane.style";
import { PaymentInformation } from "./PaymentInformation";
import { Referrals } from "../../../shared/Referrals/Referrals";
import { BankPaymentMethod, WidgetPane3ReferralsProps } from "../../../../types/WidgetProps";
import { ANONYMOUS_DONOR } from "../../../../config/anonymous-donor";
import AnimateHeight from "react-animate-height";
import { CompleteButton, CompleteButtonWrapper } from "./BankPane.style";
import { usePlausible } from "next-plausible";
import { calculateDonationBreakdown } from "../../../../utils/donationCalculations";
export const BankPane: React.FC<{
  config: BankPaymentMethod;
  referrals: WidgetPane3ReferralsProps;
}> = t0 => {
  const $ = _c(78);
  const {
    config,
    referrals
  } = t0;
  const plausible = usePlausible();
  const donation = useSelector(_temp);
  const causeAreas = useSelector(_temp2) || [];
  const [hasCompletedTransaction, setHasCompletedTransaction] = useState(false);
  let t1;
  if ($[0] !== donation.causeAreaAmounts) {
    t1 = donation.causeAreaAmounts ?? {};
    $[0] = donation.causeAreaAmounts;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== donation.orgAmounts) {
    t2 = donation.orgAmounts ?? {};
    $[2] = donation.orgAmounts;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== donation.causeAreaDistributionType) {
    t3 = donation.causeAreaDistributionType ?? {};
    $[4] = donation.causeAreaDistributionType;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== donation.operationsPercentageModeByCauseArea) {
    t4 = donation.operationsPercentageModeByCauseArea ?? {};
    $[6] = donation.operationsPercentageModeByCauseArea;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== donation.operationsPercentageByCauseArea) {
    t5 = donation.operationsPercentageByCauseArea ?? {};
    $[8] = donation.operationsPercentageByCauseArea;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const t6 = donation.selectionType ?? "single";
  const t7 = donation.selectedCauseAreaId ?? 1;
  const t8 = donation.globalOperationsEnabled ?? false;
  const t9 = donation.globalOperationsPercentage ?? 0;
  let t10;
  if ($[10] !== donation.operationsConfig?.excludedCauseAreaIds) {
    t10 = donation.operationsConfig?.excludedCauseAreaIds ?? [];
    $[10] = donation.operationsConfig?.excludedCauseAreaIds;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  const t11 = donation.operationsConfig?.operationsCauseAreaId;
  let t12;
  if ($[12] !== causeAreas || $[13] !== donation.smartDistributionTotal || $[14] !== t1 || $[15] !== t10 || $[16] !== t11 || $[17] !== t2 || $[18] !== t3 || $[19] !== t4 || $[20] !== t5 || $[21] !== t6 || $[22] !== t7 || $[23] !== t8 || $[24] !== t9) {
    t12 = calculateDonationBreakdown(t1, t2, t3, t4, t5, causeAreas, t6, t7, t8, t9, t10, t11, donation.smartDistributionTotal);
    $[12] = causeAreas;
    $[13] = donation.smartDistributionTotal;
    $[14] = t1;
    $[15] = t10;
    $[16] = t11;
    $[17] = t2;
    $[18] = t3;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
    $[24] = t9;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  const breakdown = t12;
  const totalSumIncludingTip = breakdown.totalAmount;
  let currency;
  if ($[26] !== config.locale) {
    currency = "NOK";
    if (config.locale === "sv") {
      currency = "SEK";
    } else {
      if (config.locale === "dk") {
        currency = "DKK";
      }
    }
    $[26] = config.locale;
    $[27] = currency;
  } else {
    currency = $[27];
  }
  let t13;
  if ($[28] !== currency || $[29] !== donation.kid || $[30] !== hasCompletedTransaction || $[31] !== plausible || $[32] !== totalSumIncludingTip) {
    t13 = () => {
      if (hasCompletedTransaction && totalSumIncludingTip && donation.kid) {
        plausible("CompletedDonation", {
          revenue: {
            currency,
            amount: totalSumIncludingTip
          },
          props: {
            method: "bank",
            recurring: false,
            kid: donation.kid
          }
        });
      }
    };
    $[28] = currency;
    $[29] = donation.kid;
    $[30] = hasCompletedTransaction;
    $[31] = plausible;
    $[32] = totalSumIncludingTip;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  let t14;
  if ($[34] !== hasCompletedTransaction) {
    t14 = [hasCompletedTransaction];
    $[34] = hasCompletedTransaction;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  useEffect(t13, t14);
  const t15 = hasCompletedTransaction ? 0 : "auto";
  let t16;
  if ($[36] !== config.title) {
    t16 = <PaneTitle>{config.title}</PaneTitle>;
    $[36] = config.title;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== config.kid_title || $[39] !== config.kontonr || $[40] !== config.kontonr_title || $[41] !== donation) {
    t17 = <PaymentInformation donation={donation} accountTitle={config.kontonr_title} kidTitle={config.kid_title} accountNr={config.kontonr} />;
    $[38] = config.kid_title;
    $[39] = config.kontonr;
    $[40] = config.kontonr_title;
    $[41] = donation;
    $[42] = t17;
  } else {
    t17 = $[42];
  }
  let t18;
  if ($[43] !== config.explanatory_text) {
    t18 = <InfoText>{config.explanatory_text}</InfoText>;
    $[43] = config.explanatory_text;
    $[44] = t18;
  } else {
    t18 = $[44];
  }
  let t19;
  if ($[45] !== config.explanatory_text_email_template || $[46] !== donation.donor) {
    t19 = donation.donor?.email !== ANONYMOUS_DONOR.email && donation.donor?.email && <InfoText>{config.explanatory_text_email_template.replaceAll("{email}", donation.donor.email)}</InfoText>;
    $[45] = config.explanatory_text_email_template;
    $[46] = donation.donor;
    $[47] = t19;
  } else {
    t19 = $[47];
  }
  let t20;
  if ($[48] !== config.completed_redirect) {
    t20 = () => {
      if (config.completed_redirect && config.completed_redirect.slug) {
        window.open(config.completed_redirect.slug, "_parent");
      } else {
        setHasCompletedTransaction(true);
      }
    };
    $[48] = config.completed_redirect;
    $[49] = t20;
  } else {
    t20 = $[49];
  }
  let t21;
  if ($[50] !== config.button_text || $[51] !== t20) {
    t21 = <CompleteButtonWrapper><CompleteButton onClick={t20}>{config.button_text}</CompleteButton></CompleteButtonWrapper>;
    $[50] = config.button_text;
    $[51] = t20;
    $[52] = t21;
  } else {
    t21 = $[52];
  }
  let t22;
  if ($[53] !== t15 || $[54] !== t16 || $[55] !== t17 || $[56] !== t18 || $[57] !== t19 || $[58] !== t21) {
    t22 = <AnimateHeight height={t15}>{t16}{t17}{t18}{t19}{t21}</AnimateHeight>;
    $[53] = t15;
    $[54] = t16;
    $[55] = t17;
    $[56] = t18;
    $[57] = t19;
    $[58] = t21;
    $[59] = t22;
  } else {
    t22 = $[59];
  }
  const t23 = hasCompletedTransaction ? "auto" : 0;
  let t24;
  if ($[60] !== config.completed_title) {
    t24 = <PaneTitle>{config.completed_title}</PaneTitle>;
    $[60] = config.completed_title;
    $[61] = t24;
  } else {
    t24 = $[61];
  }
  let t25;
  if ($[62] !== config.completed_text) {
    t25 = <InfoText>{config.completed_text}</InfoText>;
    $[62] = config.completed_text;
    $[63] = t25;
  } else {
    t25 = $[63];
  }
  let t26;
  if ($[64] !== t23 || $[65] !== t24 || $[66] !== t25) {
    t26 = <AnimateHeight height={t23}>{t24}{t25}</AnimateHeight>;
    $[64] = t23;
    $[65] = t24;
    $[66] = t25;
    $[67] = t26;
  } else {
    t26 = $[67];
  }
  let t27;
  if ($[68] !== t22 || $[69] !== t26) {
    t27 = <div>{t22}{t26}</div>;
    $[68] = t22;
    $[69] = t26;
    $[70] = t27;
  } else {
    t27 = $[70];
  }
  let t28;
  if ($[71] !== referrals.other_referral_input_placeholder || $[72] !== referrals.referrals_title || $[73] !== referrals.show_referrals) {
    t28 = !(referrals.show_referrals === false) && <Referrals text={{
      referrals_title: referrals.referrals_title,
      other_referral_input_placeholder: referrals.other_referral_input_placeholder
    }} />;
    $[71] = referrals.other_referral_input_placeholder;
    $[72] = referrals.referrals_title;
    $[73] = referrals.show_referrals;
    $[74] = t28;
  } else {
    t28 = $[74];
  }
  let t29;
  if ($[75] !== t27 || $[76] !== t28) {
    t29 = <Pane><PaneContainer>{t27}{t28}</PaneContainer></Pane>;
    $[75] = t27;
    $[76] = t28;
    $[77] = t29;
  } else {
    t29 = $[77];
  }
  return t29;
};
function _temp(state) {
  return state.donation;
}
function _temp2(state_0) {
  return state_0.layout.causeAreas;
}